import styled, { keyframes } from 'styled-components'
import { Color } from 'root-constants'

const dotsAnimation = keyframes`
  0% {
    opacity: 0.4;
    transform: scale(1, 1);
  }

  50% {
    opacity: 1;
    transform: scale(1.2, 1.2);
  }

  100% {
    opacity: 0.4;
    transform: scale(1, 1);
  }
`

export const StyledLoadingButton = {
  LoadingButton: styled.button`
    min-width: 88px;
    display: block;
    padding: 4px 6px;
    font-weight: 400;
    font-size: 14px;
    line-height: 19px;
    margin-right: 16px;
    cursor: pointer;
    border: 1px solid ${Color.WHITE};
    outline: none;
    background-color: transparent;
    border-radius: 42px;
    text-decoration: none;
    text-align: center;
    color: ${Color.WHITE};
    -webkit-tap-highlight-color: rgba(255, 255, 255, 0);

    & > div.loading-dots {
      display: inline-block;
      height: 8px;
      width: 8px;
      margin: 0 2px;
      animation: ${dotsAnimation} 1.5s infinite ease-in-out;
      background-color: ${Color.WHITE};
      border-radius: 50%;

      &:nth-child(2) {
        animation-delay: 0.5s;
      }

      &:nth-child(3) {
        animation-delay: 1s;
      }
    }
  `,
}
